/* DERİN v1: one canonical renderer for customer proof and frozen print layers.
   Coordinates: 103 x 153 mm including 1.5 mm bleed. 12 px/mm = 304.8 dpi. */
(() => {
  const W=1236,H=1836,S=1.2;
  const canvas=()=>Object.assign(document.createElement('canvas'),{width:W,height:H});
  const image=src=>new Promise((resolve,reject)=>{const i=new Image();i.crossOrigin='anonymous';i.onload=()=>resolve(i);i.onerror=()=>reject(Error('Unable to load the image. Please try again.'));i.src=src;});
  const crop=(ctx,img,rect,pos={})=>{
    const [x,y,w,h]=rect,zoom=Math.max(1,Math.min(4,Number(pos.zoom)||1));
    const scale=Math.max(w/img.naturalWidth,h/img.naturalHeight)*zoom;
    const dw=img.naturalWidth*scale,dh=img.naturalHeight*scale;
    const nx=Math.max(-1,Math.min(1,Number(pos.x)||0)),ny=Math.max(-1,Math.min(1,Number(pos.y)||0));
    ctx.save();ctx.beginPath();ctx.rect(x,y,w,h);ctx.clip();ctx.drawImage(img,x+(w-dw)/2+nx*(dw-w)/2,y+(h-dh)/2+ny*(dh-h)/2,dw,dh);ctx.restore();
  };
  const text=(c,value,x,y,width,size,weight='400',color='#fff')=>{
    c.fillStyle=color;c.font=`${weight} ${size}px Arial`;
    while(c.measureText(value).width>width&&size>12){size-=1;c.font=`${weight} ${size}px Arial`;}
    if(c.measureText(value).width>width)throw Error('The song title is too long for the print area.');
    c.fillText(value,x,y);
  };
  const rounded=(c,x,y,w,h,r)=>{c.beginPath();c.roundRect(x,y,w,h,r);};
  const render=async(scene,sources)=>{
    if(scene.v!==1)throw Error('Unsupported DERIN design.');
    const images=await Promise.all(sources.map(src=>src?image(src):null));
    const back=canvas(),front=canvas(),proof=canvas();const b=back.getContext('2d'),f=front.getContext('2d');b.scale(S,S);f.scale(S,S);
    const draw=(c,index,rect)=>{if(images[index])crop(c,images[index],rect,scene.crops[index]);else{c.fillStyle='#eee9e1';c.fillRect(...rect);}};
    if(scene.model==='spotify-collage'){
      for(let n=0;n<6;n++)draw(b,n,[(n%2)*515,Math.floor(n/2)*510,515,510]);
    }else if(scene.model==='baby'&&scene.background!=='original'){
      if(!scene.backgroundUrl)throw Error('Unable to load the selected background.');
      crop(b,await image(scene.backgroundUrl),[0,0,1030,1530]);
    }else draw(b,0,[0,0,1030,1530]);
    if(scene.model.startsWith('spotify')){
      f.fillStyle='#141414';rounded(f,181,193,669,1144,70);f.fill();
      f.save();rounded(f,217,257,603,600,37);f.clip();
      const cover=scene.coverMode==='photo'?images[scene.model==='spotify-collage'?6:1]:scene.track?.artwork;
      if(cover){if(typeof cover==='string')crop(f,await image(cover),[217,257,603,600]);else crop(f,cover,[217,257,603,600],scene.crops[scene.model==='spotify-collage'?6:1]);}
      else{f.fillStyle='#d8d3cd';f.fillRect(217,257,603,600);}f.restore();
      text(f,scene.track?.title||'Choose your song',206,928,616,45,'700');
      text(f,scene.track?.artist||'',206,972,616,36,'400','#bbb');
      f.strokeStyle='#6e6e6e';f.lineWidth=8;f.lineCap='round';f.beginPath();f.moveTo(212,1025);f.lineTo(818,1025);f.stroke();
      f.strokeStyle='#fff';f.beginPath();f.moveTo(212,1025);f.lineTo(595,1025);f.stroke();
      text(f,'0:00',212,1064,180,24,'400','#ccc');text(f,scene.track?.duration||'0:00',751,1064,75,24,'400','#ccc');
      f.fillStyle='#fff';
      for(const x of [335,365]){f.beginPath();f.moveTo(x,1138);f.lineTo(x-28,1158);f.lineTo(x,1178);f.closePath();f.fill();}
      for(const x of [666,696]){f.beginPath();f.moveTo(x,1138);f.lineTo(x+28,1158);f.lineTo(x,1178);f.closePath();f.fill();}
      f.fillRect(495,1129,13,58);f.fillRect(524,1129,13,58);
      f.strokeStyle='#777';f.lineWidth=7;f.beginPath();f.moveTo(238,1220);f.lineTo(796,1220);f.stroke();f.strokeStyle='#eee';f.beginPath();f.moveTo(238,1220);f.lineTo(615,1220);f.stroke();
      if(scene.track?.code){
        const code=await image(scene.track.code),white=document.createElement('canvas');white.width=code.naturalWidth;white.height=code.naturalHeight;
        const wc=white.getContext('2d');wc.drawImage(code,0,0);wc.globalCompositeOperation='source-in';wc.fillStyle='#fff';wc.fillRect(0,0,white.width,white.height);
        f.drawImage(white,292,1221,447,447*white.height/white.width);
      }
    }else if(scene.model==='collage'){
      // Frame arrangement follows supplied front printing plate: top tilted,
      // middle straight, bottom slightly tilted, with opaque white borders.
      const point=([x,y])=>[(x-654.262)*1030/291.969,(443.622-y)*1530/433.701];
      const frames=[
        {index:3,tl:[731.0749,193.6295],tr:[864.9739,175.4965],bl:[713.7949,66.0335]},
        {index:1,tl:[757.7665,405.6426],tr:[891.6655,387.5096],bl:[740.4865,278.0466]},
        {index:2,tl:[708.8273,300.3829],tr:[843.8993,304.0429],bl:[712.3153,171.6689]}
      ];
      frames.forEach(({index,tl,tr,bl})=>{
        const [x,y]=point(tl),[tx,ty]=point(tr),[bx,by]=point(bl);
        f.save();f.transform((tx-x)/480,(ty-y)/480,(bx-x)/460,(by-y)/460,x,y);
        f.fillStyle='#fff';f.fillRect(-11,-11,502,482);draw(f,index,[0,0,480,460]);f.restore();
      });
      await document.fonts.load('80px "Derin Script"');
      b.fillStyle='#201c18';const words=(scene.caption||'Our Kind of Chaos').trim().split(/\s+/);const split=Math.ceil(words.length/2);
      for(const [i,line] of [words.slice(0,split).join(' '),words.slice(split).join(' ')].entries()){let size=80;b.font=`${size}px "Derin Script"`;while(b.measureText(line).width>340&&size>20)b.font=`${--size}px "Derin Script"`;b.fillText(line,56,100+i*77);}
    }else if(scene.model==='baby'&&scene.cutout){
      crop(f,await image(scene.cutout),[0,0,1030,1530],scene.crops[0]);
    }
    const p=proof.getContext('2d');p.drawImage(back,0,0);p.drawImage(front,0,0);
    return {back,front,proof};
  };
  window.RenaoDerinRenderer={render,image,crop,width:W,height:H};
})();
